export default __webpack_public_path__ + "static/ms-onedrive-d8214fc70bf228d8282385fa6d7a1ba8.svg";